export default "__VITE_ASSET__202b196c__"